import React from 'react';
import './ContactSection.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const ContactSection = () => {
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { t, lang } = useLanguage();

  const contactDetails = [
    { 
      label: lang === 'TR' ? "FİRMA" : lang === 'AR' ? "الشركة" : "COMPANY", 
      value: "Bigma Grup Biotechnologies A.Ş." 
    },
    { 
      label: lang === 'TR' ? "ADRES" : lang === 'AR' ? "العنوان" : "ADDRESS", 
      value: lang === 'TR' 
        ? "Organize Sanayi Bölgesi 3. Kısım 6. Cad. No:49 Sivas" 
        : lang === 'AR'
        ? "المنطقة الصناعية المنظمة، القسم الثالث، الشارع السادس، رقم: 49، سيواس / تركيا"
        : "Organized Industrial Zone 3rd Section 6th St. No:49 Sivas / Turkey" 
    },
    { 
      label: lang === 'TR' ? "TELEFON" : lang === 'AR' ? "الهاتف" : "PHONE", 
      value: "0346 218 18 25 / 0555 876 99 66" 
    },
    { 
      label: "WEB", 
      value: "www.bigmagrup.com.tr" 
    },
    { 
      label: lang === 'TR' ? "RUHSAT KURALI" : lang === 'AR' ? "قاعدة الترخيص" : "LICENSE RULE", 
      value: lang === 'TR'
        ? "Yalama taşı hariç tüm ürünlerde TR:5800051; yalnızca yalama taşında TR:5800481"
        : lang === 'AR'
        ? "TR:5800051 لجميع المنتجات باستثناء أحجار اللعق؛ TR:5800481 لأحجار اللعق فقط"
        : "TR:5800051 for all products except licking blocks; TR:5800481 for licking blocks only"
    },
    { 
      label: lang === 'TR' ? "DİLLER" : lang === 'AR' ? "اللغات" : "LANGUAGES", 
      value: "TR | EN | AR | RU | FR | 中文" 
    }
  ];

  return (
    <section className="contact-modern-section">
      <div className="contact-container">
        
        <div className="contact-text-side">
          {/* t() fonksiyonu ile translations.js'den çekiyoruz kanka */}
          <span className="contact-badge">{t('contact.badge')}</span>
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.desc')}</p>
        </div>

        <div className="contact-info-grid">
          {contactDetails.map((item, index) => (
            <div key={index} className="contact-info-card">
              <span className="info-label">{item.label}</span>
              <p className="info-value">{item.value}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ContactSection;